/**
 * Page views — Build 39 (Daniel 2026-09-20).
 *
 * `record` is fire-and-forget by design. It is called on every navigation and
 * must never make anybody wait, never throw into a render, and never show an
 * error. If a view is lost, the count is one short. Nothing else happens.
 */
import { apiFetch } from '../auth/api';

export interface PathRow {
  path: string;
  views: number;
  people: number;
  last_day: string;
}

export interface PersonRow {
  user_id: number;
  first_name: string | null;
  last_name: string | null;
  views: number;
  paths: number;
  active_days: number;
}

export function recordPageView(path: string): void {
  void apiFetch('/api/page-views', {
    method: 'POST',
    body: JSON.stringify({ path }),
  }).catch(() => undefined);
}

export function getPageViewSummary(days: number): Promise<{
  days: number;
  from: string;
  paths: PathRow[];
  people: PersonRow[];
}> {
  return apiFetch(`/api/page-views/summary?days=${days}`);
}
